const DEFAULT_GRADIENT_COLORS = [
  { color: '#0079FD', position: '-37.91%' },
  { color: '#2D51FB', position: '20.11%' },
  { color: '#5A29FA', position: '78.13%' },
  { color: '#8800F8', position: '137.91%' },
];

export const BACKGROUND_PRIMARY = '#FFFFFF';
export const BACKGROUND_SECONDARY = '#F7F7F7';

export const SURFACE_NEUTRAL_DEFAULT = '#FFFFFF';
export const SURFACE_ACCENT_DEFAULT = '#E6F7FF';
export const SURFACE_SUCCESS_DEFAULT = '#EDFDE7';
export const SURFACE_WARNING_DEFAULT = '#FEFBE1';
export const SURFACE_CRITICAL_DEFAULT = '#FFEDE5';
export const SURFACE_INVERSE = '#8A8A8A';

export const FILL_NEUTRAL_DEFAULT = '#FFFFFF';
export const FILL_ACCENT_DEFAULT = {
  colors: DEFAULT_GRADIENT_COLORS,
  direction: '90deg',
};
export const FILL_SUCCESS_SELECTED = '#008321';
export const FILL_WARNING_SELECTED = '#FDDD40';
export const FILL_CRITICAL_SELECTED = '#FDDD40';
export const FILL_DECORATIVE_GRADIENT = {
  colors: DEFAULT_GRADIENT_COLORS,
  direction: '90deg',
};
export const FILL_DECORATIVE_01 = '#C865FC';
export const FILL_DECORATIVE_02 = '#62F5D2';
export const FILL_DECORATIVE_03 = '#6CE95D';
export const FILL_DECORATIVE_04 = '#FEE766';
export const FILL_DECORATIVE_05 = '#FFB169';
export const FILL_INVERSE_DEFAULT = '#1C1C1C';

export const SURFACE_OVERLAY_BACKDROP = '#000000AD';
export const SURFACE_OVERLAY_IMAGE = '#00000085';
export const SURFACE_OVERLAY_LUMINOSITY_NEGATIVE_3 = '#00000047';
export const SURFACE_OVERLAY_LUMINOSITY_NEGATIVE_2 = '#0000001F';
export const SURFACE_OVERLAY_LUMINOSITY_NEGATIVE_1 = '#0000000A';
export const SURFACE_OVERLAY_LUMINOSITY_POSITIVE_1 = '#FFFFFF47';
export const SURFACE_OVERLAY_LUMINOSITY_POSITIVE_2 = '#FFFFFF85';
export const SURFACE_OVERLAY_LUMINOSITY_POSITIVE_3 = '#FFFFFFC2';

export const CONTENT_PRIMARY = '#1C1C1C';
export const CONTENT_SECONDARY = '#616161';
export const CONTENT_TERTIARY = '#B5B5B5';
export const CONTENT_ACCENT_DEFAULT = {
  colors: DEFAULT_GRADIENT_COLORS,
  direction: '90deg',
};
export const CONTENT_ACCENT_HOVER_OVERLAY = '#FFFFFF29';
export const CONTENT_ACCENT_SELECTED_OVERLAY = '#FFFFFF52';
export const CONTENT_ON_SUCCESS = '#FFFFFF';
export const CONTENT_SUCCESS = '#009D19';
export const CONTENT_ON_WARNING = '#795800';
export const CONTENT_WARNING = '#926E00';
export const CONTENT_ON_CRITICAL = '#FFFFFF';
export const CONTENT_CRITICAL = '#DB082C';
export const CONTENT_ON_DECORATIVE_01 = '#37008F';
export const CONTENT_ON_DECORATIVE_02 = '#006681';
export const CONTENT_ON_DECORATIVE_03 = '#006A24';
export const CONTENT_ON_DECORATIVE_04 = '#926E00';
export const CONTENT_ON_DECORATIVE_05 = '#931B01';
export const CONTENT_INVERSE = '#FFFFFF';
export const CONTENT_ON_INVERSE = '#1C1C1C';
export const CONTENT_ON_OVERLAY = '#FFFFFF';
export const CONTENT_DISABLED = '#D4D4D4';

export const BORDER_NEUTRAL_DEFAULT = '#EBEBEB';
export const BORDER_NEUTRAL_HOVER = '#D4D4D4';
export const BORDER_NEUTRAL_SELECTED = '#B5B5B5';
export const BORDER_ACCENT_DEFAULT = {
  colors: DEFAULT_GRADIENT_COLORS,
  direction: '90deg',
};
export const BORDER_ACCENT_HOVER_OVERLAY = '#FFFFFF29';
export const BORDER_ACCENT_SELECTED_OVERLAY = '#FFFFFF52';
export const BORDER_SUCCESS = '#008321';
export const BORDER_WARNING = '#B68C01';
export const BORDER_CRITICAL = '#B70634';
export const BORDER_DISABLED = '#D4D4D4';
export const BORDER_FOCUS = '#65BDFE';
export const BORDER_FOCUS_INVERSE = '#FFFFFF';

export const LINK_DEFAULT = '#0045B6';
export const LINK_HOVER = {
  colors: DEFAULT_GRADIENT_COLORS,
  direction: '90deg',
};
export const LINK_VISITED = '#6900D5';
export const LINK_INVERSE_DEFAULT = '#FFFFFF';
export const LINK_INVERSE_HOVER = '#D4D4D4';
export const LINK_INVERSE_VISITED = '#E098FE';
